import { Modal, Table } from 'antd';
import React, { useMemo, useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { ModalHeader } from 'datastake-daf/dist/components';
import Style from '../style';
import Input, { BasicInput } from './input';
import { useGeneralContext } from '../../../context/General';
import { getLocales } from '../../../components/Table/newTable';
import { useTranslation } from 'react-i18next';

const RepeatableGroup = ({
  name = null,
  config = {},
  data = {},
  allData = {},
  linkingData = {},
  linkingForms = {},
}) => {
  const { t } = useTranslation();
  const { ajaxOptions } = useGeneralContext();
  const { automaticallyLink, dataLink, call } = useMemo(() => config, [config]);
  const entity = useMemo(() => automaticallyLink?.entity || config?.meta?.dataLinkEntity, [automaticallyLink, config]);
  const isAjaxModal = useMemo(() => automaticallyLink && dataLink && call, [automaticallyLink, dataLink, call]);
  const [modalRow, setModalRow] = useState(null)
  const dataSource = useMemo(() => allData[name] || [], [allData, name]);

  const _data = useMemo(() =>
    dataSource.length ? dataSource.map((f, i) => {
      if (isAjaxModal && typeof f === 'string' && linkingData && linkingData[entity] && linkingData[entity][f]) {
        const value = linkingData[entity][f];
        return { ...value, key: i };
      }

      if (config?.meta?.ajaxOptionsKey) {
        if (linkingData && linkingData[entity] && linkingData[entity][f[config?.meta?.ajaxOptionsKey]]) {
          const value = linkingData[entity][f[config?.meta?.ajaxOptionsKey]];

          return { ...value, key: i };
        }

        const options = ajaxOptions[config?.meta?.ajaxOptionsKey];

        if (Array.isArray(options)) {
          const value = options.find((v) => v.value === f[config?.meta?.ajaxOptionsKey])

          if (value) {
            return { ...f, ...value, key: i };
          }
        }
      }

      return { ...f, key: i };
    }
    ) : [{ key: 1, isEmpty: true }, { key: 2, isEmpty: true }]
    , [isAjaxModal, dataSource, entity, config, ajaxOptions, linkingData]);

  const mapKey = (key) => ({
    title: config?.inputs[key].label,
    key: key,
    dataIndex: key,
    ellipsis: true,
    render: (v, all) => {
      if (all.isEmpty) {
        return <div className="daf-default-cell md" />;
      }

      if (v) {
        return (
          <BasicInput
            name={key}
            key={key}
            config={config.inputs[key]}
            valueOnlyString
            data={all}
          />
        );
      }

      return '--';
    },
  });

  const columns = [
    ...(Array.isArray(config?.meta?.tableKeys) ? config.meta.tableKeys.map(mapKey) : Object.keys(config?.inputs).map(mapKey)),
    {
      key: 'actions',
      dataIndex: 'actions',
      label: '',
      width: 50,
      render: (_, all) => {
        if (all.isEmpty) {
          return <div className="daf-default-cell md" />;
        }

        return (
          <div
            onClick={() => setModalRow(all)}
            className="cursor-pointer flex justify-content-center">
            <EyeOutlined />
          </div>
        )
      }
    }
  ];

  const _subTitle = config.viewSubTitle || config.subTitle

  return (
    <div className="group repeatable">
      <div className="daf-title with-subtitle">
        <h1>{config.label}</h1>
        {_subTitle && typeof _subTitle === 'string' ? (
          <p>{_subTitle}</p>
        ) : null}
      </div>

      <div className="daf-table-wrapper no-padding repeatable-form-table input no-pagination">
        <Table
          locale={getLocales(t)}
          pagination={false}
          columns={columns}
          dataSource={_data}
          rowKey="key"
        />
      </div>
      <Modal
        open={!!modalRow}
        title={(<ModalHeader title={config.label} />)}
        footer={null}
        width={650}
        className="max-h-50"
        onCancel={() => setModalRow(null)}
      >
        <Style>
          <div className="view-content">
            <div className="content no-padding">
              <div className="wrapper">
                <div className='group'>
                  <Input
                    config={
                      Object.keys(config.inputs || {})
                        .filter((k) => {
                          return !(config?.meta?.excludedKeysView || []).includes(k)
                        })
                        .reduce((all, key) => {
                          all[key] = config.inputs[key];
                          return all;
                        }, {})
                    }
                    data={{ ...modalRow }}
                  />
                </div>
              </div>
            </div>
          </div>
        </Style>
      </Modal>
    </div>
  );
}

export default RepeatableGroup;
